import getAxiosClient from "../config/axios";

const getAppInfoBaseUrl = () => {
    return `/api/public/app-info`;
}

const AppInfoApiClient = {
    getAppInfo: async () => {
        const response = await getAxiosClient().get(getAppInfoBaseUrl());
        return response.data;
    }
};

export default AppInfoApiClient;

